import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'btn-toggle',
    templateUrl: './btn-toggle.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BtnToggleComponent),
            multi: true
        }
    ],
    standalone: false
})
export class BtnToggleComponent {
	@Input() formLabel: string = '';
	@Input() formLabelClass: string = '';
	@Input() formLabelPostion: 'left' | 'right' = 'left';
	@Input() isInvalid: false;
	@Input() isStatic: boolean = false;
	@Input() onLabel: string = 'Labels.Yes';
	@Input() offLabel: string = 'Labels.No';
	@Input() isStaticButton = false;

	private _checked: boolean;
	private _disabled: boolean;
	private _isFromFO: boolean;

	@Input()
	set isFromFO(isFromFO: boolean) {
		this._isFromFO = isFromFO === true;
	}

	get isFromFO(): boolean {
		return this._isFromFO;
	}

	@Input()
	set checked(checked: boolean) {
		this._checked = checked;
	}

	get checked(): boolean {
		return this._checked;
	}

	@Input()
	set disabled(disabled: boolean) {
		this._disabled = disabled;
	}

	get disabled(): boolean {
		return this._disabled;
	}

	get stateLabel(): string {
		return this.checked ? this.onLabel : this.offLabel;
	}

	get stateClass(): string {
		return this.checked ? 'is-on' : 'is-off';
	}

	get isBackOffice(): string {
		return this._isFromFO ? '' : '-back';
	}

	@Output() change = new EventEmitter<boolean>();
	@Output() changeEvent = new EventEmitter<MouseEvent>();
	@Output() valueChange = new EventEmitter<boolean>();

	constructor(private cdr: ChangeDetectorRef) {}

	onChange(event: MouseEvent): void {
		if (this.disabled) {
			return;
		}

		event.preventDefault();

		this.checked = !this.checked;

		// Component events
		this.change.emit(this.checked);
		this.valueChange.emit(this.checked);
		this.changeEvent.emit(event);

		// value accessor callbacks
		this.onChangeCallback(this.checked);
		this.onTouchedCallback(this.checked);
		this.cdr.markForCheck();
	}

	writeValue(checked: boolean): void {
		this.checked = checked;
		if (this.cdr) {
			this.cdr.markForCheck();
		}
	}

	registerOnChange(fn: any): void {
		this.onChangeCallback = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouchedCallback = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	private onTouchedCallback = (v: any) => {};
	private onChangeCallback = (v: any) => {};
}
